export const EXTERNAL_LINK_DEFAULT_VALUE = false;
export const IS_FULL_DEFAULT_VALUE = false;

export interface ShoppingCartConfig {
  enabled: boolean;
  url: string;
  externalLink: boolean;
  isFull: boolean;
  hasUnreadNotifications: boolean;
}
